import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'templates.Edit e-mail sending options' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form class="form" ng-submit="vm.save()">
                <div class="row">
                    <span class="label">{{ 'templates.Send e-mails' | translate }}</span>
                    <div class="items">
                        <ul class="checkboxes">
                            <li>
                                <label>
                                    <input ng-disabled="vm.loading" type="radio" name="emailSetting"
                                    ng-checked="!vm.isWithoutLimits && !vm.isNotificationsSendingBlocked" ng-click="vm.checkSendingTimes()">
                                    <span class="text">{{ 'templates.Between' | translate }}</span>
                                    <select ng-disabled="true" class="form-control small">
                                        <option ng-model="vm.startSendingNotificationsAt" value="vm.defaultModel.start">{{ vm.defaultModel.start }}:00</option>
                                    </select>
                                    <span class="text">{{ 'templates.and' | translate }}</span>
                                    <select ng-disabled="true" class="form-control small">
                                        <option ng-model="vm.stopSendingNotificationsAt" value="vm.defaultModel.stop">{{ vm.defaultModel.stop }}:00</option>
                                    </select>
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input ng-disabled="vm.loading" type="radio" name="emailSetting"
                                    ng-checked="vm.isWithoutLimits && !vm.isNotificationsSendingBlocked" ng-click="vm.removeSendingTimes()">
                                    {{ 'templates.Without limits (24/7)' | translate }}
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input ng-disabled="vm.loading" type="radio" name="emailSetting"
                                    ng-checked="vm.isNotificationsSendingBlocked" ng-click="vm.blockSendingNotifications()">
                                    {{ 'templates.Never (no notification emails will be sent)' | translate }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <span class="label">{{ 'templates.Enable summary reminder e-mail' | translate }}</span>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox" ng-model="vm.form.model.groupReminderNotifications" name="switch">
                            <span>{{ 'general.Yes' | translate }}</span>
                        </label>
                    </div>
                </div>
                <button type="submit" class="hidden" >{{ 'licence.Save licence' | translate }}</button>
            </form>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li ng-if="!vm.loading" class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, FormFactory, CompanyResource, TokenService, ModalService, MomentService) {
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.CompanyResource = CompanyResource;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.loading = true;
    }

    $onInit () {
        // start and stop can only be defaultModel values or null,
        // so for now this is all we need to generate select values
        this.defaultModel = { start: '08', stop: '20' };

        this.CompanyResource.get({
            id: this.TokenService.getCompanyId()
        }).$promise.then(company => {
            this.oldModelStartSending = company.startSendingNotificationsAt;
            this.oldModelStopSending = company.stopSendingNotificationsAt;
            this.isNotificationsSendingBlocked = Boolean(company.isNotificationsSendingBlocked);
            this.oldModelIsWithoutLimits = this.isWithoutLimits = this.oldModelStartSending === null && this.oldModelStopSending === null;
            this.companyTimezone = company.timezone;

            this.form = this.FormFactory.create(
                this.defaultModel,
                model => this.CompanyResource.setNotificationReceivingHours(model).$promise
            );

            this.form.model.startSendingNotificationsAt = this.oldModelStartSending;
            this.form.model.stopSendingNotificationsAt = this.oldModelStopSending;
            this.form.model.groupReminderNotifications = Boolean(company.groupReminderNotifications);
            this.form.model.isNotificationsSendingBlocked = this.isNotificationsSendingBlocked;
            this.loading = false;
        });
    }

    checkSendingTimes () {
        this.isWithoutLimits = false;
        this.isNotificationsSendingBlocked = false;
        this.form.model.isNotificationsSendingBlocked = false;

        this.form.model.startSendingNotificationsAt = `${this.defaultModel.start}:00:00`;
        this.form.model.stopSendingNotificationsAt = `${this.defaultModel.stop}:00:00`;
    }

    removeSendingTimes () {
        this.isWithoutLimits = true;
        this.isNotificationsSendingBlocked = false;
        this.form.model.isNotificationsSendingBlocked = false;

        this.form.model.startSendingNotificationsAt = null;
        this.form.model.stopSendingNotificationsAt = null;
    }

    blockSendingNotifications () {
        this.isWithoutLimits = false;
        this.isNotificationsSendingBlocked = true;
        this.form.model.isNotificationsSendingBlocked = true;

        this.form.model.startSendingNotificationsAt = null;
        this.form.model.stopSendingNotificationsAt = null;
    }

    save () {
        if (this.oldModelIsWithoutLimits === false && this.isWithoutLimits === true && !this.isCompanyMessageReceivingHours()) {
            const message = this.$translate.instant('templates.messages_will_be_sent_out_immediately');
            this.ModalService.confirm(message, 'medium').then(
                () => this.form.save().then(() => this.uibModalInstance.close())
            );
        }
        else {
            this.form.save().then(() => this.uibModalInstance.close());
        }
    }

    // Mirrors ReceivingHoursPolicy::isWithinReceivingHours on the backend:
    // the window is inclusive at the start and exclusive at the end, so with the usual
    // 08:00-20:00 setting the 20:00 hour is already outside it.
    isCompanyMessageReceivingHours () {
        const nowHour = this.MomentService.convertToTimezone(new Date(), this.companyTimezone, 'HH');
        const startTime = this.oldModelStartSending.split(':');
        const stopTime = this.oldModelStopSending.split(':');

        return nowHour >= startTime.shift() && nowHour < stopTime.shift();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/template/edit/sendingOptions/index.js